import React from "react";
import styled from "styled-components";
import { Grid, ListItem } from "@material-ui/core";
import Theme from "../../Theme";
import { withRouter, RouteComponentProps } from "react-router";
import IHeaderMenuItem from "../../models/IHeaderMenuItem";
import getSection from "./getSection";
import getLocationInfo from "../../functions/getLocationInfo";
import isHeaderMenuItemSelected from "../../functions/isHeaderMenuItemSelected";

const AreaGrid = styled(Grid)`
  background-color: ${Theme.colors.lightBackground};
  font-family: ${Theme.fonts.header};
  display: flex;
  flex-direction: column;
`;

const AreaExpander = styled(Grid)`
  display: flex;
  flex-direction: row;
`;

const AreaItem = styled(ListItem)`
  min-width: 150px;
  padding: 20px 10px;
  font-size: 16px;
  font-weight: bold;
  color: ${Theme.colors.blackText};
  text-align: center;
  justify-content: center;
`;

export interface IDocHeaderMenuProps extends RouteComponentProps {}

const DocHeaderMenu = (props: IDocHeaderMenuProps) => {
  const { location, history } = props;
  const { doc } = getLocationInfo(location);
  let items: Array<IHeaderMenuItem> = [];

  const handleClick = (item: IHeaderMenuItem) => () => {
    history.push(item.href);
  };

  if (doc) {
    items = getSection(doc).headerMenu;
  }

  return (
    <AreaGrid>
      <AreaExpander item xs={12} sm={8} lg={4} xl={2}>
        {items.map(item => (
          <AreaItem button selected={isHeaderMenuItemSelected(item)} key={item.name} onClick={handleClick(item)}>
            {item.name}
          </AreaItem>
        ))}
      </AreaExpander>
    </AreaGrid>
  );
};

export default withRouter(DocHeaderMenu);
